import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from 'react-responsive-modal';

const ConfirmNavigation = ({
  message, isOpen, onConfirm, onCancel,
}) => (
  <Modal
    open={isOpen}
    center
    onClose={onCancel}
    classNames={{
      overlay: 'loading-overlay',
      modal: classNames({
        'modal-wrapper': true,
        'confirm-navigation': true,
      }),
    }}
  >
    <div>
      <h2>Leaving?</h2>
      <p>{message}</p>
      <div className="actions">
        <button type="button" className="btn cancel" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="btn confirm" onClick={onConfirm}>
          Leave
        </button>
      </div>
    </div>
  </Modal>
);

ConfirmNavigation.displayName = 'ConfirmNavigation';

ConfirmNavigation.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmNavigation;



// WEBPACK FOOTER //
// ./src/components/modals/ConfirmNavigation.js